<div class="service-configuration">
  <app-contract-steps-bar [stepNo]="2"></app-contract-steps-bar>
  @if (!initializeInProgress && configuratorInitialized) {
    <div class="service-configuration__content">
      <div class="service-configuration__steps">
        @if (selectedSystem) {
          <h5 class="steps__title">
            {{ selectedSystem.name }}
            {{ 'service-configuration.steps-service-name' | translate }}
          </h5>
        }
        <app-configuration-steps-bar
          [currentStep]="currentStep"
          [steps]="configurationSteps"
          (selectStep)="changeStep($event)">
        </app-configuration-steps-bar>
      </div>
      <div class="service-configuration__options">
        @for (config of serviceConfigurations; track config) {
          @if (config.description === configurationSteps[currentStep]?.value) {
            <h4 class="service-configuration__options-title">{{ config.description }}</h4>
            <p class="service-configuration__options-tip">{{ 'service-configuration.config-tip' | translate }}</p>
            @for (configMember of config.members; track configMember) {
              <app-configuration
                [config]="configMember"
                [disableInput]="saveInProgress"
                (changed)="configChanged($event)">
              </app-configuration>
            }
          }
        }
        @if ('Contract details' !== configurationSteps[currentStep]?.value) {
          <div
            class="service-configuration__actions">
            <button type="button" class="button button--primary" [attr.data-test]="'button-next'" [disabled]="saveInProgress" (click)="goToTheNextStep()">
              {{ 'service-configuration.next-step-btn' | translate }}
            </button>
            @if (saveInProgress) {
              <span class="service-configuration__actions-marker">
                <span class="loading-animation"></span>
                {{ 'service-configuration.saving' | translate }}
              </span>
            }
            @if (showSaveDone && !saveInProgress) {
              <span class="service-configuration__actions-marker save-done">
                <span class="icon icon-check icon-check__circle"></span>
                <span>{{ 'service-configuration.save-done' | translate }}</span>
              </span>
            }
            @if (currentStep > 0) {
              <button
                type="button"
                class="button" [attr.data-test]="'button-backToPreviousStep'"
                [disabled]="saveInProgress"
                (click)="goBackToPreviousStep()">
                {{ 'service-configuration.back-step-btn' | translate }}
              </button>
            }
          </div>
        }
        @if ('Contract details' === configurationSteps[currentStep]?.value) {
          <app-contract-details
            [configId]="configId"
            [saveInProgress]="saveInProgress"
            [showSaveDone]="showSaveDone"
            (changed)="handleContractChange($event)"
            (goBack)="goBackToPreviousStep()"
            (goToReviewSummary)="goToTheNextStep()">
          </app-contract-details>
        }
      </div>
      <div class="service-configuration__summary">
        <div class="summary-navigation">
          <div
            class="summary-navigation__item"
            [ngClass]="{'active': activeSummary === 'price-list'}"
            (click)="toggleSummaryTab('price-list')">
            {{ 'service-configuration.summary-nav-option1' | translate}}
          </div>
          <div
            class="summary-navigation__item"
            [ngClass]="{'active': activeSummary === 'change-log'}"
            (click)="toggleSummaryTab('change-log')">
            <span class="summary-navigation__item-marker" [ngClass]="{'icon-dot': showNewChangeMarker}">
              {{ 'service-configuration.summary-nav-option2' | translate}}
            </span>
          </div>
        </div>
        @if (activeSummary === 'price-list') {
          <app-price-list
            [priceList]="priceList"
            [priceSummary]="priceSummary">
          </app-price-list>
        }
        @if (activeSummary === 'change-log') {
          <app-change-log
            [changeLog]="changeLog">
          </app-change-log>
        }
      </div>
    </div>
  } @else {
    <div class="service-configuration__loader" [ngClass]="{'loader__fixed': initializeInProgress}">
      <div class="loading-animation"></div>
      @if (showAlmostThere) {
        <p>{{ 'service-configuration.almost-there-loader' | translate }}</p>
      }
    </div>
  }
</div>

<app-conflict-modal
  [open]="conflictModalActive"
  [conflict]="conflict"
  (accept)="acceptConflict()"
  (undo)="conflictModalActive = false">
</app-conflict-modal>
